import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo-white.png'
import _imports_1 from '../assets/logo-blue.png'


const _withScopeId = n => (_pushScopeId("data-v-4f180f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "logo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.path === 'Home')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "logo__src",
            src: _imports_0,
            alt: "logo-white",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/')))
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "logo__src",
            src: _imports_1,
            alt: "logo-blue",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/')))
          }))
    ]),
    (_ctx.screenInfo.isPlatform === 'desktop' || (_ctx.screenInfo.isPlatform === 'mobile' && _ctx.path !== 'Home'))
      ? (_openBlock(), _createBlock(_component_Menu, {
          key: 0,
          "screen-info": _ctx.screenInfo
        }, null, 8, ["screen-info"]))
      : _createCommentVNode("", true)
  ]))
}